<div class="modal_dialog order-cancel-confirm-modal">
  <div class="modal_header">
    <h2>{{ title }}</h2>
    <button class="btnn close_icon" type="button" (click)="onCancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="modal_body">
    <div class="confirm-content">
      <div class="confirm-icon" aria-hidden="true">!</div>
      <p class="confirm-message">{{ message }}</p>
      <p class="order-ref" *ngIf="orderLabel">{{ orderLabel }}</p>
    </div>

    <div class="action-buttons">
      <button type="button" class="btnn btn_secondary" (click)="onCancel()">
        {{ cancelLabel }}
      </button>
      <button type="button" class="btnn btn_primary" (click)="onConfirm()">
        {{ confirmLabel }}
      </button>
    </div>
  </div>
</div>
